module.exports = __webpack_public_path__ + "static/media/brij.4b32cdfe.webp";